import QAndAChart from './QAndAChart.component';

export default QAndAChart;